import ShopDatalayer from '@curry/shop'
import Shop from '../models/shop'

export default class ShopApi {
  constructor({ config, transports }) {
    this.datalayer = new ShopDatalayer({ config, transports });
  }

  get({ id, locale = 'en_US' }) {
    return new Promise((resolve, reject) => {
      const args = { id, locale };

      this.datalayer.models[0].findById({ args })
      .then((response) => {
        resolve(new Shop(Shop.format(response.data)));
      }).catch(reject);
    });
  }
}